export const reviewTitleMinLength = 5;
export const reviewTitleMaxLength = 100;
export const reviewMinLength = 10;
export const reviewMaxLength = 600;
